import { Injectable, inject } from '@angular/core';
import { from, Observable } from 'rxjs';
import { VwApiRequestsService, VwApiResponse, VW_ERROR_CODES } from 'vwappservices';
import { ToastrService } from 'ngx-toastr';

export enum SubTaxes {
  "CGST" = 0,
  "SGST" = 1,
  "IGST" = 2
}

@Injectable({ providedIn: 'root' })
export class CommonServicesService {

  public pageTitle = "";
  public isActive: boolean = true;
  public invoiceData: any = {};

  private vwApi = inject(VwApiRequestsService);
  private toster = inject(ToastrService);

  // _baseurl kept for backward compatibility with callers â€” library resolves base URL automatically.
  getGenericTable(master: string, _baseurl: any = '', additionalParam = ''): Observable<VwApiResponse> {
    const paramObj: any = { master };
    if (additionalParam) paramObj['addsummary'] = additionalParam;
    return from(this.vwApi.getAPICall('master/getcommonmastertable', paramObj));
  }

  populateDropdown(ddlname: any, _baseurl: any = ''): Observable<VwApiResponse> {
    return from(this.vwApi.getAPICall('common/populateddl', { ddlname }));
  }

  async getCurrentRates(branchid: number): Promise<any[]> {
    const res = await this.vwApi.postAPICall('common/getcurrentrates', { branchid });
    return res?.errorCode === VW_ERROR_CODES.SUCCESS ? (res?.Data?.currentrates ?? []) : [];
  }

  async getPaymentModes(): Promise<any[]> {
    const res = await this.vwApi.postAPICall('common/getpaymentmodes', {});
    return res?.errorCode === VW_ERROR_CODES.SUCCESS ? (res?.Data?.paymentmodes ?? []) : [];
  }

  async getReceiptModes(): Promise<any[]> {
    const res = await this.vwApi.postAPICall('common/getreceiptmodes', {});
    return res?.errorCode === VW_ERROR_CODES.SUCCESS ? (res?.Data?.receiptmodes ?? []) : [];
  }

  getConditionalDDL = async (params: any): Promise<any> => {
    const res = await this.vwApi.postAPICall('common/getconditionalddl', params);
    if (res.errorCode === VW_ERROR_CODES.SUCCESS) {
      return res.Data ?? [];
    }
    this.toster.error('Error while getting section list');
    return [];
  };

  getDistictDDL = async (params: any): Promise<any> => {
    const res = await this.vwApi.postAPICall('common/getdistictddl', params);
    if (res.errorCode === VW_ERROR_CODES.SUCCESS) {
      return res.Data ?? [];
    }
    this.toster.error('Error while getting section list');
    return [];
  };

  checkUniqueFields = async (params: any): Promise<VwApiResponse> => {
    return this.vwApi.postAPICall('common/checkuniquefields', params);
  };

  checkCrmMobileNo = async (params: any): Promise<VwApiResponse> => {
    return this.vwApi.postAPICall('common/checkcrmmobileno', params);
  };

  getSalesmanDetails = async (params: any): Promise<VwApiResponse> => {
    return this.vwApi.postAPICall('invoice/getsalesmanlist', params);
  };

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.vwApi.uploadFile('savePdf/upload/savePdf', file, { localPath: file.name.split('.')[0] });
    }
  }

  restrictCharacters(str: string): boolean {
    const invalidChars = ["<", ">", "~", "\\", "-", "+", "."];
    return invalidChars.includes(str);
  }

  acceptCharacterOnly(event: any): boolean {
    var charCode = event.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 32 || charCode == 8)
      return true;
    else
      return false;
  }

  acceptNumberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  getCityList(stateList: any): any[] {
    var cityList: any[] = [];

    for (let i = 0; i < stateList.length; i++) {
      const stateObj = stateList[i];

      if (!stateObj['cities']) continue;

      let cities: any[] = stateObj['cities'];

      if (cities.length === 1 && typeof cities[0] === 'string') {
        try {
          let citiesStr = cities[0];
          if (!citiesStr.startsWith('[')) citiesStr = `[${citiesStr}]`;
          cities = JSON.parse(citiesStr);
        } catch (error: any) {
          console.error("JSON Parse Error:", error.message);
          continue;
        }
      }

      if (!Array.isArray(cities)) continue;

      for (const cityObj of cities) {
        if (cityObj && cityObj['value'] !== undefined && cityObj['display']) {
          cityList.push({
            "stateId": stateObj['value'],
            "value": cityObj['value'],
            "display": cityObj['display']
          });
        }
      }
    }

    return cityList;
  }

  getCityList_Old(stateList: any): any[] {
    var cityList: any[] = [];
    for (let i = 0; i < stateList.length; i++) {
      const stateObj = stateList[i];
      if (stateObj['cities'] != undefined) {
        if (stateObj['cities'][0]) {
          let cities: any = [];
          cities = [];
          cities.push(JSON.parse(stateObj['cities'][0]));
          for (let ctindx = 0; ctindx < cities.length; ctindx++) {
            const cityObj = cities[ctindx];
            cityList.push({
              "stateId": stateObj['value'],
              "value": cityObj['value'],
              "display": cityObj['display']
            });
          }
        }
      }
    }
    return cityList;
  }

  prepareDropdownList(dropdownList: any, oprFor: string, concatTo: string, keyOneToConcat: string, keyTwoToConcat: string): any[] {
    var dropdownListToReturn = [];
    if (oprFor == "seachableDDL") {
      for (let i = 0; i < dropdownList.length; i++) {
        dropdownList[i]['label'] = dropdownList[i]['display'];
        dropdownList[i]['value'] = (dropdownList[i]['value']).toString();
        dropdownListToReturn.push(dropdownList[i]);
      }
    }
    else if (oprFor == 'concatKeys') {
      for (let i = 0; i < dropdownList.length; i++) {
        const element = dropdownList[i];
        dropdownList[i][concatTo] = element[keyOneToConcat] + ' - ' + element[keyTwoToConcat];
        dropdownListToReturn.push(dropdownList[i]);
      }
    }
    return dropdownListToReturn;
  }

  hideTaxColumns(stateCode: any, tableid: any, hideAllOnZero: boolean = false): void {
    let unHideColms = [
      { "key": "cgst", "flag": false },
      { "key": "sgst", "flag": false },
      { "key": "igst", "flag": false },
    ];
    if (stateCode == 27 || stateCode == 0) {
      unHideColms[SubTaxes.CGST].flag = true;
      unHideColms[SubTaxes.SGST].flag = true;
    } else {
      unHideColms[SubTaxes.IGST].flag = true;
    }
    if (hideAllOnZero) {
      unHideColms[SubTaxes.CGST].flag = false;
      unHideColms[SubTaxes.SGST].flag = false;
      unHideColms[SubTaxes.IGST].flag = false;
    }
  }

  emptyValidationMsg(event: any, FOR: string): any {
    var answer: string = event ? event : "";
    var anslength = 0;
    if (answer.toString().length) {
      anslength = answer.toString().length;
      if ((FOR == 'mobileno1' || FOR == 'mobileno2') && answer) {
        if (anslength >= 10) return false;
        return "Mobile no. of 10 digit is required";
      }
      else if ((FOR == 'phoneno2' || FOR == 'phoneno') && answer) {
        if (anslength >= 10) return false;
        return "Phone no. of 10 digit is required";
      }
      else if (FOR == 'pincode' && answer) {
        if (anslength >= 6) return false;
        return "Pincode of 6 digit is required";
      }
    }
  }

  setMaxLength(event: any, value: any, FOR: string): any {
    if (event.keyCode == 46 || event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 9) return true;
    if (event.keyCode == 189 || event.keyCode == 187 || event.key == ".") {
      event.preventDefault();
      return;
    }
    var answer: string = value ? value : "";
    if (answer.toString().length && event['code'] != "Backspace") {
      const anslength = answer.toString().length;
      if (FOR == 'phoneno' && answer) {
        if (anslength >= 10) return false;
        return "Phone no. of 10 digit is required.";
      }
      else if (FOR == 'pincode' && answer) {
        if (anslength >= 6) return false;
        return "Pincode of 6 digit is required.";
      }
    }
    return true;
  }

  getCurrentDate(): string {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();
    return dd + '-' + mm + '-' + yyyy;
  }

  addBlankRow(tableHeaders: any, tableid: any, autoFillPurity: boolean = false, extComnArr: any[] = []): any {
    let blankRow: any = {};
    if (tableid == 'GenerateModSlipTable') {
      tableHeaders.forEach((ele: any) => {
        if (ele.key == 'gstrate' || ele.key == 'gstamt') ele.visiblecolm = false;
      });
    }
    for (let index = 0; index < tableHeaders.length; index++) {
      const element = tableHeaders[index];
      if (element['datatype'] == "string") blankRow[element['key']] = "";
      else if (element['datatype'] == "dropdown") blankRow[element['key']] = "";
      else if (element['datatype'] == "number") {
        blankRow[element['key']] = 0;
        if (element['decimaldigit'])
          blankRow[element['key']] = +blankRow[element['key']].toFixed(element['decimaldigit']);
      }
      else if (element['datatype'] == "date") blankRow[element['key']] = null;
      if (element['key'] == "purity" && autoFillPurity) blankRow[element['key']] = 100;
    }
    for (let index = 0; index < extComnArr.length; index++) {
      const element = extComnArr[index];
      blankRow[element['key']] = element['defValue'];
    }
    return blankRow;
  }

  getAmountByTax(amountin: any, percentage: any, netAmount: any): any {
    let calculatedPercentageAmount = 0;
    let obj: any = {};
    if (amountin == 'inpercentage') {
      calculatedPercentageAmount = ((netAmount * percentage) / 100);
    } else {
      calculatedPercentageAmount = ((percentage * 100) / netAmount);
    }
    obj['percentAmount'] = calculatedPercentageAmount ? (calculatedPercentageAmount).toFixed(2) : 0;
    obj['grossamount'] = (netAmount + (+calculatedPercentageAmount)).toFixed(2);
    return obj;
  }

  avoidMinusPlus(event: any, floatAllowed: any, returnOnEnter?: any): any {
    if (event.keyCode == 189 || event.keyCode == 187 || event.keyCode == 69) {
      event.preventDefault();
      return;
    }
    if (floatAllowed && event.key == ".") return true;
    else if (!floatAllowed && event.key == ".") return false;
    if (returnOnEnter == true && event.keyCode == 13) return;
  }

  loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = false;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script ${src}`));
      document.head.appendChild(script);
    });
  }
}
